module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-02.b8bf062d.png";